import { render, staticRenderFns } from "./flood-risk-report.vue?vue&type=template&id=4d6baa64&scoped=true&"
import script from "./flood-risk-report.vue?vue&type=script&lang=js&"
export * from "./flood-risk-report.vue?vue&type=script&lang=js&"
import style0 from "./flood-risk-report.vue?vue&type=style&index=0&id=4d6baa64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6baa64",
  null
  
)

export default component.exports